import { tierKey } from '../../utils/tierStyles';

export const viewerTier = (user) =>
  (user && user.subscription_status === 'active' ? tierKey(user.subscription_plan) : null);

/** Headline discount for a merchant card, from the viewer's point of view. */
export function dealFor(m, tier) {
  const pro = m.pro_discount_pct || 0;
  const elite = m.elite_discount_pct || 0;
  if (m.has_offer) {
    if (tier === 'elite') return { pct: elite, label: `${elite}% OFF`, sub: 'your Elite price' };
    if (tier === 'pro') return { pct: pro, label: `${pro}% OFF`, sub: elite > pro ? `Elite gets ${elite}%` : 'your Pro price' };
    return { pct: elite, label: `Up to ${elite}% OFF`, sub: 'for AGA members' };
  }
  if (m.max_service_discount_pct > 0) return { pct: m.max_service_discount_pct, label: `Up to ${m.max_service_discount_pct}% OFF`, sub: 'on member pricing' };
  return null;
}

const PALETTE = ['#00E676', '#00E5FF', '#FFD740', '#FF6E9C', '#B388FF', '#FF9100'];
export function initialsOf(name) {
  const words = (name || '?').replace(/[^A-Za-z0-9 ]/g, ' ').split(/\s+/).filter(Boolean);
  return (words[0]?.[0] || '?').toUpperCase() + (words[1]?.[0] || '').toUpperCase();
}
export function colorOf(name) {
  let h = 0;
  for (const c of name || '') h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length];
}
